<template>
    <div class="item-card item-card--region" @click="handleClick">
        <!-- Image -->
        <div class="image" :style="{ 'background-image': 'url(' + item.image +')' }"></div>

        <!-- Name -->
        <span class="name">
            {{ item.name }}
        </span>

        <!-- Property count -->
        <small class="property-count" v-if="item.property_count">
            {{ item.property_count }}
            Unterkünfte
        </small>
    </div>
</template>

<script>
    export default {
        props: ['item'],
        data() {
            return {}
        },
        mounted() {},
        computed: {},
        methods: {
            handleClick() {
                this.$emit('click', this.item)
            },
        },
        watch: {}
    }
</script>
